import { HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

export const SectionDescription = ({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLParagraphElement>) => (
  <span className={cn('text-sm', className)} {...props}>
    {children}
  </span>
)
